export default __webpack_public_path__ + "static/media/Telegram-icon.3864902c.png";